import * as messageBox from './ui-message-box.js'
import * as buttonSprite from './ui-button-sprite.js'

export default async function procSplit(params) {
    const { app, w, h, cards } = params;

    // Show message
    const text = 'カードを上から3つに切ります\n切りたいカードの上でタップしてください';
    const mes = messageBox.gen(app, text);
    mes.y = h * 0.15;

    // Function split cards
    const splitCards = (x, y, range) => {
        const pArr = cards.map((card, i) => {
            if (i < range.start || i > range.end) return;
            card.zIndex = card.__indexSort;
            const p = anime({targets: card, x, y, easing: 'linear'}).finished;
            y -= 4;
            buttonSprite.offClick(card);
            return p;
        });
        return pArr;
    };

    // Split cards
    const splits = [];
    const baseY = h * 0.85;
    await new Promise(resolve => {
        cards.forEach((card, i) => {
            buttonSprite.onClick(card, async () => {
                if (splits.length === 0) {
                    // Split 1st
                    if (i >= cards.length - 2) return;

                    splits[0] = {start: 0, end: i};
                    splitCards(w * 0.2, baseY, splits[0]);
                } else
                if (splits.length === 1) {
                    // Split 2nd
                    if (i >= cards.length - 1 || i <= splits[0].end) return;

                    splits[1] = {start: splits[0].end + 1, end: i};
                    const pArr1 = splitCards(w * 0.5, h * 0.85, splits[1]);

                    splits[2] = {start: splits[1].end + 1, end: cards.length - 1};
                    const pArr2 = splitCards(w * 0.8, baseY, splits[2]);

                    // Split end
                    await Promise.all(pArr1.concat(pArr2));
                    mes.destroy();
                    params.splits = splits;
                    resolve();
                }
            });
        });
    });
}
